"use strict";

/**
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 * /!\                                                                     /!\
 * /!\   WARNING THIS FILE IS AUTOMATICALLY GENERATED. DO NOT ALTER IT'S   /!\
 * /!\      CONTENTS MANUALLY. UPDATE THE TEMPLATE FILE INSTEAD.           /!\
 * /!\                                                                     /!\
 * /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\ /!\
 */
const create = require('../base.js');

//
// @ux/require: './index.css';
//
// Unfortunately, WebPack decided to remove the ability to use labels as require
// indicator as that would be the only way we could make WebPack automatically
// bundle files without them actually being required serverside.
//
module.exports = create('phone', 'false');